import React, {Component} from 'react'
import PropTypes from "prop-types";
import '../../components_style/rtl_css/FormElementContainer.css'
import '../../components_style/FormElementContainer.css'
import SvGraphics from "../../assets/SvGraphics";


class FormElementContainerExpanded extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isExpanded:true,
        };
    }

    componentDidMount() {
    }

    onClickArrow= ()=> {
        this.props.changeTabInternalView(this.props.currentContainerView)
        this.setState({isExpanded: !this.state.isExpanded})
    }


    render() {
        let {title,Component,rest,isSub,docWidth,SubTitle} = this.props
        let {isExpanded}= this.state


        isExpanded = docWidth<1200 ? this.props.currentContainerView === this.props.tabInternalView : true
        let titleClass ='patientsFormBoxes-title-text-label'
        let arrowClass ='patient-onboard-arrow-responsive'
        let arrowClassRotate ='patient-onboard-arrow-rotate-responsive'
        if(SubTitle){
            titleClass ='patientsFormBoxes-title-text-label2'
            arrowClass='patient-onboard-arrow-responsive2'
            arrowClassRotate='patient-onboard-arrow-rotate-responsive2'
        }
        return (
            <div  className={'patientForm-box-container'}>
                { {title}!=='' ?
                    <div className={isExpanded?'patientsFormBoxes-title-text':'patientsFormBoxes-title-board-responsive'} id={isExpanded?'patientsFormBoxes-title-text':'patientsFormBoxes-title-board-responsive'} style={{display:'flex'}}>
                        <label className={titleClass}> {title}</label>
                        {SubTitle&&<a className={"patientsFormBoxes-sub-title-text"}
                            href={'https://www.sade.group/he/documents/'} target={"_blank"}>{SubTitle}</a>}

                        <SvGraphics id={'svg-responsive'} className={!isExpanded?arrowClass:arrowClassRotate} width={'15px'} height={'15px'} svgname={'arrow-down'} onClick={()=>this.onClickArrow()}/>
                    </div>
                    : ""}
                {isExpanded && <Component {...rest} />}
            </div>

        )
    }
}

FormElementContainerExpanded.propTypes = {
    title: PropTypes.string.isRequired,
    Component: PropTypes.elementType.isRequired,
    rest: PropTypes.object
};

export default FormElementContainerExpanded;
